module.exports = __webpack_public_path__ + "static/media/ignore-active-icon.5af62706.svg";